import React, {Component} from 'react';
import IMAGES from "./assets/data";

export default class Pricing extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <section className="py-20 bg-greenPW text-gray-100" id="pricing">
          <div className="container px-4 mx-auto">
            <div className="max-w-2xl mx-auto mb-16 text-center">
              <h2 className="text-4xl font-bold lg:text-5xl text-bezowyPW">Wybierz bilet</h2>
            </div>
            <div className="flex flex-wrap items-stretch -mx-4">
              <div className="flex w-full mb-8 sm:px-4 md:w-1/2 lg:w-1/3 lg:mb-0">
                <div className="flex flex-col p-6 space-y-6 rounded  sm:p-8 bg-bezowyPW">
                  <div className="space-y-2">
                    <h4 className="text-xl font-bold">Kongres Młodych Naukowców</h4>
                    <span className="text-2xl font-bold">PLN</span>
                    <span className="text-4xl font-bold"> {IMAGES.bilety.a}
                      <h4 className="text-xl font-bold">LICZBA MIEJSC OGRANICZONA</h4>

						</span>
                  </div>
                  <p className="mt-3 leading-relaxed text-greenPW text-xl">Bilet obejmuje:</p>
                  <ul className="flex-1 mb-6 text-greenPW text-xl">
                    <li className="flex mb-2 space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Udział w Kongresie Młodych Naukowców PW</span>
                    </li>
                    <li className="flex mb-2 space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Lunch w czasie Kongresu</span>
                    </li>
                  </ul>
                  <div
                    className="inline-block px-5 py-3 font-semibold tracking-wider text-center rounded bg-orangePW text-greenPW">
                    <a rel="noopener noreferrer" href="https://rdpw.pw.edu.pl/konferencja/"
                       className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-violet">Kup
                      Bilet</a>
                  </div>
                </div>
              </div>
              <div className="flex w-full mb-8 sm:px-4 md:w-1/2 lg:w-1/3 lg:mb-0">
                <div className="flex flex-col p-6 space-y-6 rounded shadow sm:p-8 bg-bezowyPW">
                  <div className="space-y-2">
                    <h4 className="text-xl font-bold">Bal Młodych Naukowców</h4>
                    <span className="text-3xl font-bold">PLN</span>
                    <span className="text-6xl font-bold"> {IMAGES.bilety.b}
                      <h4 className="text-xl font-bold">PREZAPISY do 8.01.2023 LUB WYCZERPANIA I PULI</h4>

						</span>
                  </div>
                  <p className="leading-relaxed text-greenPW text-xl">Bilet obejmuje:</p>
                  <ul className="flex-1 space-y-2 text-greenPW text-xl">
                    <li className="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Udział w Balu Młodych Naukowców PW</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Udział w Kongresie Młodych Naukowców PW</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Lunch w czasie Kongresu</span>
                    </li>
                  </ul>
                  <div
                    className="inline-block px-5 py-3 font-semibold tracking-wider text-center rounded bg-orangePW text-greenPW">
                    <a rel="noopener noreferrer" href={IMAGES.bilety.link}
                       className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-violet">Kup
                      Bilet</a>
                  </div>
                </div>
              </div>
              <div className="flex w-full mb-8 sm:px-4 md:w-1/2 lg:w-1/3 lg:mb-0 opacity-40 ">
                <div className="flex flex-col p-6 space-y-6 rounded shadow sm:p-8 bg-bezowyPW">
                  <div className="space-y-2">
                    <h4 className="text-xl font-bold">Bal Młodych Naukowców</h4>
                    <span className="text-2xl font-bold">PLN</span>
                    <span className="text-4xl font-bold"> {IMAGES.bilety.c}
                      <h4 className="text-xl font-bold">CENA REGULARNA</h4>
						</span>
                  </div>
                  <p className="mt-3 leading-relaxed text-greenPW text-xl">Bilet obejmuje:</p>
                  <ul className="flex-1 mb-6 text-greenPW">
                    <li className="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Udział w Balu Młodych Naukowców PW</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Udział w Kongresie Młodych Naukowców PW</span>
                    </li>
                    <li className="flex mb-2 space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                           className="flex-shrink-0 w-6 h-6 text-violet">
                        <path fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"></path>
                      </svg>
                      <span>Lunch w czasie Kongresu</span>
                    </li>
                  </ul>
                  <div
                    className="inline-block px-5 py-3 font-semibold tracking-wider text-center rounded bg-orangePW text-greenPW  ">
                    <a rel="noopener noreferrer"
                       className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-violet cursor-not-allowed">Kup
                      Bilet</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  };
}
